import { PLUGIN_TYPE } from '@/typings/enums/PLUGIN_TYPE';
import BaseEntity from '../BaseEntity';
import { PLUGIN_EVENT_TYPE } from '@/typings/enums/PLUGIN_EVENT_TYPE';

type LockedStatus = {
  label: string,
  color: Orion.Color,
  icon: string,
}

export default class UnlockModuleOrderAgencyListItemEntity<T extends ICompanyWithOrderPluginModel> extends BaseEntity<T> {

	get name () { return this.state.name;}
	get contactDetailCity () { return this.state.contactDetailCity;}
	get plugins () { return this.state.plugins;}

	get isActive () {
		return this.state.plugins.find(x => x.type === PLUGIN_TYPE.Order)?.isActive;
	}

	get pluginRequest () {
		const plugin = this.state.plugins.find(x => x.type === PLUGIN_TYPE.Order);
		return plugin?.events.find(x => x.type === PLUGIN_EVENT_TYPE.Requested);
	}

	get agencyLockedStatus () : LockedStatus {
		if (this.isActive) {
			return {
				label: `Abonnement actif`,
				color: 'success',
				icon: 'icon-interface-unlock',
			};
		} else if (!this.pluginRequest) {
			return {
				label: `Module de test`,
				color: 'default',
				icon: 'icon-interface-lock',
			};
		} else return {
			label: `En attente d'activation`,
			color: 'info',
			icon: 'icon-interface-lock',
		};
	}
}
